export default __webpack_public_path__ + "static/media/aquarium02_05.5df512cb.png";